import TableContainer from "components/Common/TableContainer"
import React, { useMemo } from "react"
import { Badge, Card, CardBody, UncontrolledTooltip } from "reactstrap"
import { formatBDT } from "utils/formatPrice"

export default function MoneyReceiptsTab({ }) {
  const isLoading = false
  const data = {
    data: [
      {
        id: 1,
        number: "MR-001",
        date: "2025-01-15",
        amount: 50000,
        customer: "John Doe",
      },
      {
        id: 2,
        number: "MR-002",
        date: "2025-01-20",
        amount: 75000,
        customer: "Jane Smith",
      },
    ],
    pagination: {
      current_page: 1,
      from: 1,
      last_page: 1,
      to: 2,
      total: 2,
    },
  }

  // Money Receipts Table Columns
  const moneyReceiptColumns = useMemo(
    () => [
      {
        header: "Receipt No",
        accessorKey: "number",
      },
      {
        header: "Date",
        accessorKey: "date",
      },
      {
        header: "Customer",
        accessorKey: "customer",
      },
      {
        header: "Amount",
        accessorKey: "amount",
        cell: ({ row }) => formatBDT(row.original.amount),
      },
      {
        header: "Action",
        cell: ({ row }) => (
          <ul className="list-unstyled hstack gap-1 mb-0">
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-info"
                id={`view-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-eye-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`view-tooltip-${row.original.id}`}
                >
                  View
                </UncontrolledTooltip>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn btn-sm btn-soft-primary"
                id={`download-tooltip-${row.original.id}`}
              >
                <i className="mdi mdi-download" />
                <UncontrolledTooltip
                  placement="top"
                  target={`download-tooltip-${row.original.id}`}
                >
                  Download
                </UncontrolledTooltip>
              </button>
            </li>
          </ul>
        ),
      },
    ],
    []
  )
  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Money Receipts</h5>
          <Badge color="primary" pill className="px-3 py-2">
            {data.pagination.total} records
          </Badge>
        </div>

        <TableContainer
          columns={moneyReceiptColumns}
          data={data.data}
          isPagination={true}
          paginationInfo={data.pagination}
          loading={isLoading}
        />
      </CardBody>
    </Card>
  )
}
